/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import GatewayLogRouters from './gateway-log.routes';
import GatewayLogController from './gateway-log.controller';
import GatewayLogDirective from './gateway-log.directive';

export default angular.module('tektelic.gatewayLog', [])
    .config(GatewayLogRouters)
    .controller('GatewayLogController', GatewayLogController)
    .directive('tkGatewayLog', GatewayLogDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/gateway-log/index.js